import { createAction, props } from '@ngrx/store';
import { WorkflowLetterTemplate } from './workflow-letter-template.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records workflow letter template'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records workflow letter template success', 
    props<{ listData: WorkflowLetterTemplate[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records workflow letter template failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record workflow letter template',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record workflow letter template success', 
    props<{ singleData: WorkflowLetterTemplate }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record workflow letter template failure', 
    props<{ error: string }>()
);


// Update Data
export const updateRecord = createAction(
    '[Data] Update record workflow letter template',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record workflow letter template success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record workflow letter template failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state workflow letter template',
);